module.exports = __webpack_public_path__ + "static/media/WearConcrete_Product Listings.db51d1a3.docx";